import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollTopButton from './components/ScrollTopButton';
import Chatbot from './components/Chatbot';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import Solutions from './pages/Solutions';
import Pricing from './pages/Pricing';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import BecomePartner from './pages/BecomePartner';
import FeaturesDetail from './pages/FeaturesDetail';
import PitchTech from './pages/PitchTech';
import Testimonials from './pages/Testimonials';
import BlogDetail from './pages/BlogDetail';

function App() {
  useEffect(() => {
    // Initialize WOW.js and other jQuery plugins after component mounts
    // BUT exclude React-managed sections (testimonials)
    if (window.jQuery && window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true,
        callback: function(box) {
          // Prevent WOW.js from animating React-managed elements
          if (box && (
            box.closest('[data-react-root="true"]') ||
            box.hasAttribute('data-react-component')
          )) {
            return false; // Skip this element
          }
        },
        scrollContainer: null
      });
      wow.init();
    }
    
    // Initialize other plugins
    if (window.jQuery) {
      window.jQuery(document).ready(function($) {
        if ($.fn.niceSelect) {
          $('select').niceSelect();
        }
        if ($.fn.slick) {
          // Initialize slick if needed for other sections
        }
      });
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes - With Header/Footer */}
        <Route path="/" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <Home />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/about" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <About />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/features" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <Features />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/solutions" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <Solutions />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/pricing" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <Pricing />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/blog" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <Blog />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/contact" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <Contact />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/become-partner" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <BecomePartner />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/features-detail" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <FeaturesDetail />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/pitch-tech" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <PitchTech />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/testimonials" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <Testimonials />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
        <Route path="/blog/:id" element={
          <div className="page-wrapper">
            <Header />
            <ScrollToTop />
            <BlogDetail />
            <Footer />
            <ScrollTopButton />
            <Chatbot />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;

